import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { authenticatedFetch } from "@shopify/app-bridge-utils";

export const newClient = (app) => {
  const gqlBaseUrl = process.env.WEB_URL || "";

  const apolloCache = new InMemoryCache();

  const uploadLink = createUploadLink({
    uri: `${gqlBaseUrl}/graphql`,
    fetch: authenticatedFetch(app),
    headers: {
      "keep-alive": "true",
    },
  });

  return new ApolloClient({
    cache: apolloCache,
    link: uploadLink,
  });
}
